import React from "react";
import Logo from "../../../../utils/components/Logo";
import Marty from "marty";

let Invite = React.createClass({
    render() {
        return (
            <section className="eo-view invite">
              <div id="talkable-invite"></div>
            </section>
        );
    }
});

export default Marty.createContainer(Invite);



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/invite/Handler.js
 **/